import { NextPageContext } from 'next'
import { Store } from 'redux'
import ProgramPage from './index'
import { getProgramsPageProps } from '../../bll/getProgramsPageProps'

ProgramPage.getInitialProps = async (
  ctx: NextPageContext & { store: Store }
): Promise<any> => {
  const { store } = ctx

  const { notFound, content } = await getProgramsPageProps({ ctx, store })

  if (notFound) {
    if (ctx?.res) {
      ctx.res.statusCode = 404
    }

    return {
      notFound: true,
    }
  }

  return {
    content,
  }
}

export default ProgramPage
